import { render, staticRenderFns } from "./TicketCategory.vue?vue&type=template&id=12eb5b5f&scoped=true&"
import script from "./TicketCategory.vue?vue&type=script&lang=js&"
export * from "./TicketCategory.vue?vue&type=script&lang=js&"
import style0 from "./TicketCategory.vue?vue&type=style&index=0&id=12eb5b5f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12eb5b5f",
  null
  
)

export default component.exports